// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aSEO","content":"styles_content__Ntwbi","row":"styles_row__1Y5as","footer":"styles_footer__7Wepi","phraseLength":"styles_phraseLength__qhU7l"};